module.exports = __webpack_public_path__ + "static/img/5.f8be5a7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/3/eng/5.png
// module id = 2kpi
// module chunks = 0